import {Route} from 'react-router-dom';
import RestaurantBase from '../components/template/base/RestaurantBase';
import {AddOnsRoutes} from './AddOnsRoutes';
import {Reserve,Customer,Report,Settings,ReserveSettings,OtherSettings,View,ShopSettings} from "../components/pages/reserve";

export const BlocksReserveRoutes = (
    <Route path="restaurants/:restaurantId" element={<RestaurantBase />}>
        {/* BESPO関連のルートを追加 */}
        <Route path="reserve/view" element={<View />} />
        <Route path="reserve/reserve" element={<Reserve />} />
        <Route path="reserve/customer" element={<Customer />} />
        <Route path="reserve/report" element={<Report />} />
        <Route path="reserve/settings" element={<Settings />} />
        <Route path="reserve/reserve_settings" element={<ReserveSettings />} />
        <Route path="reserve/other_settings" element={<OtherSettings />} />
        <Route path="reserve/shop_settings" element={<ShopSettings />} />
        {AddOnsRoutes}
    </Route>
);